(function () {
  'use strict';

  var STORAGE_KEY = 'paradise-posters:favourite';

  function storageAvailable() {
    try {
      var testKey = '__favourite_test__';
      window.localStorage.setItem(testKey, testKey);
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      console.warn('Favourites: localStorage unavailable, favourites will not persist.', error);
      return false;
    }
  }

  function formatPrice(cents) {
    var amount = parseInt(cents, 10);
    if (isNaN(amount)) {
      return '';
    }
    if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === 'function') {
      return theme.Shopify.formatMoney(amount, theme.money_format);
    }
    return '$' + (amount / 100).toFixed(2);
  }

  function parseCents(value) {
    if (typeof value === 'number') return value;
    var num = parseInt(value, 10);
    return isNaN(num) ? NaN : num;
  }

  function parseCents(value) {
    if (typeof value === 'number') return value;
    var match = String(value || '').match(/\d+/);
    return match ? parseInt(match[0], 10) : NaN;
  }

  function getThemeString(key, fallback) {
    if (window.theme && theme.strings && theme.strings[key]) {
      return theme.strings[key];
    }
    return fallback;
  }

  var Favourites = {
    items: [],
    storageEnabled: false,
    variantCache: {},
    cardCache: {},
    wiggleTimer: null,

    init: function init() {
      if (typeof window === 'undefined' || typeof document === 'undefined') return;
      this.storageEnabled = storageAvailable();
      this.items = this.storageEnabled ? this.load() : [];
      this.cacheDom();
      this.bindEvents();
      // Ensure we have variant pricing for saved items
      this.items.forEach(function (item) {
        Favourites.hydrateVariants(item);
      });
      this.render();
    },

  cacheDom: function cacheDom() {
    this.panel = document.querySelector('[data-favourite-panel]');
    this.overlay = document.querySelector('[data-favourite-overlay]');
    this.itemsContainer = document.querySelector('[data-favourite-items]');
    this.emptyMessage = document.querySelector('[data-favourite-empty]');
    this.bulkContainer = document.querySelector('[data-favourite-bulk]');
    this.footer = document.querySelector('[data-favourite-footer]');
    this.pageContainer = document.querySelector('[data-favourite-page]');
    this.pageItemsContainer = document.querySelector('[data-favourite-page-items]');
    this.pageEmptyMessage = document.querySelector('[data-favourite-page-empty]');
    this.variantSelect = document.querySelector('[data-favourite-variant]');
    this.addButton = document.querySelector('[data-favourite-add]');
    this.status = document.querySelector('[data-favourite-status]');
    this.countTotal = document.querySelector('[data-favourite-count-total]');
    this.viewAllLink = document.querySelector('[data-favourite-view-all]');
  },

  bindEvents: function bindEvents() {
    document.addEventListener('click', this.handleClick.bind(this));
    document.addEventListener('keydown', this.handleKeydown.bind(this));
    document.addEventListener('theme:cartchanged', this.handleCartChanged.bind(this));
    if (this.variantSelect) {
      this.variantSelect.addEventListener('change', this.toggleAddButton.bind(this));
    }
  },

  handleCartChanged: function handleCartChanged() {
    var _this = this;
    // Header gets re-rendered on cart changes; refresh badges after it swaps in.
    window.setTimeout(function () {
      _this.render();
    }, 120);
  },

    handleClick: function handleClick(event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var toggleButton = target.closest('[data-favourite-toggle]');
      if (toggleButton) {
        event.preventDefault();
        this.toggleItem(toggleButton);
        return;
      }

      var removeButton = target.closest('[data-favourite-remove]');
      if (removeButton) {
        event.preventDefault();
        var handle = removeButton.getAttribute('data-product-handle');
        this.remove(handle);
        return;
      }

      var openButton = target.closest('[data-favourite-open]');
      if (openButton) {
        event.preventDefault();
        this.openPanel(openButton);
        return;
      }

      if (this.overlay && target === this.overlay) {
        this.closePanel();
      }

      var closeButton = target.closest('[data-favourite-close]');
      if (closeButton) {
        event.preventDefault();
        this.closePanel();
      }

      var addButton = target.closest('[data-favourite-add]');
      if (addButton) {
        event.preventDefault();
        this.addAllToCart();
      }

      var viewAll = target.closest('[data-favourite-view-all]');
      if (viewAll) {
        this.trackFavouriteEvent('view_all_favourites', {
          label: 'view_all_link',
          item_count: this.items.length
        });
      }
    },

    handleKeydown: function handleKeydown(event) {
      if (event.key === 'Escape' && this.isPanelVisible()) {
        this.closePanel();
      }
    },

    toggleItem: function toggleItem(button) {
      var product = this.extractProduct(button);
      if (!product.handle) return;
      var exists = this.items.some(function (item) {
        return item.handle === product.handle;
      });
      if (exists) {
        this.items = this.items.filter(function (item) {
          return item.handle !== product.handle;
        });
      } else {
        this.items.push(product);
        this.hydrateVariants(product);
      }
      this.save();
      this.render();
      if (!exists) {
        this.animateFavouriteIcon();
      }
      this.trackAnalytics(exists ? 'remove' : 'add', product);
    },

    remove: function remove(handle) {
      if (!handle) return;
      var removedItem = this.items.find(function (item) {
        return item.handle === handle;
      });
      this.items = this.items.filter(function (item) {
        return item.handle !== handle;
      });
      this.save();
      this.render();
      if (removedItem) {
        this.trackAnalytics('remove', removedItem);
      }
    },

    trackAnalytics: function trackAnalytics(action, product) {
      if (!product) return;
      var label = product.handle || product.id || 'unknown';
      var variant = product.variantId || '';
      if (typeof window.gtag === 'function') {
        var eventName = action === 'add' ? 'favourite_toggle_on' : action === 'remove' ? 'favourite_toggle_off' : 'favourite_toggle';
        window.gtag('event', eventName, {
          event_category: 'engagement',
          event_label: label,
          favourite_action: action,
          item_id: product.id || '',
          item_variant: variant
        });
      } else if (typeof window.ga === 'function') {
        var gaAction = action === 'add' ? 'favourite_toggle_on' : action === 'remove' ? 'favourite_toggle_off' : action;
        window.ga('send', 'event', 'favourites', gaAction, label + (variant ? ' | ' + variant : ''), {
          nonInteraction: true
        });
      }
    },

    animateFavouriteIcon: function animateFavouriteIcon() {
      var triggers = document.querySelectorAll('[data-favourite-open]');
      if (!triggers.length) return;
      triggers.forEach(function (trigger) {
        trigger.classList.remove('favourite-link--wiggle');
        void trigger.offsetWidth;
        trigger.classList.add('favourite-link--wiggle');
      });
      if (this.wiggleTimer) {
        window.clearTimeout(this.wiggleTimer);
      }
      this.wiggleTimer = window.setTimeout(function () {
        triggers.forEach(function (trigger) {
          trigger.classList.remove('favourite-link--wiggle');
        });
      }, 700);
    },

    trackDrawer: function trackDrawer(state) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'favourite_drawer', {
          event_category: 'engagement',
          event_label: state
        });
      } else if (typeof window.ga === 'function') {
        window.ga('send', 'event', 'favourite_drawer', state, null, {
          nonInteraction: true
        });
      }
    },

    trackFavouriteEvent: function trackFavouriteEvent(action, payload) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', action, Object.assign({
          event_category: 'favourites'
        }, payload || {}));
      } else if (typeof window.ga === 'function') {
        var label = payload && payload.label ? payload.label : '';
        window.ga('send', 'event', 'favourites', action, label, {
          nonInteraction: true
        });
      }
    },

    extractProduct: function extractProduct(button) {
      var dataset = button.dataset;
      var variants = this.parseVariantsFromCard(button);
      var product = {
        id: dataset.productId || '',
        handle: dataset.productHandle || '',
        title: dataset.productTitle || '',
        url: dataset.productUrl || '#',
        image: dataset.productImage || '',
        price: dataset.productPrice || '',
        variantId: dataset.variantId || '',
        variants: variants
      };
      var variants = this.parseVariantsFromCard(button);
      if (variants.length) {
        product.variants = variants;
      }
      return product;
    },

    parseVariantsFromCard: function parseVariantsFromCard(button) {
      var card = button.closest('.product-block');
      return this.parseVariantsFromElement(card);
    },

    parseVariantsFromElement: function parseVariantsFromElement(card) {
      if (!card) return [];
      var script = card.querySelector('.bulk-add-variant-data');
      if (!script) return [];
      try {
        var parsed = JSON.parse(script.textContent || '[]');
        return (parsed || []).map(function (variant) {
          return {
            id: variant.id,
            title: variant.title,
            price: typeof variant.price === 'number' ? variant.price : parseCents(variant.price)
          };
        }).filter(function (variant) {
          return variant.id && variant.title;
        });
      } catch (error) {
        return [];
      }
    },

    hydrateVariants: function hydrateVariants(item) {
      if (item.variants && item.variants.length) return item;
      if (!item.handle) return item;

      // Use cached variants if available
      if (Array.isArray(this.variantCache[item.handle])) {
        item.variants = this.variantCache[item.handle];
        return item;
      }

      // Try to read variants from a product card on the page
      var cardButton = document.querySelector('.product-block [data-product-handle="' + item.handle + '"]');
      if (cardButton) {
        var block = cardButton.closest('.product-block') || cardButton;
        var variantsFromDom = this.parseVariantsFromElement(block);
        if (variantsFromDom.length) {
          item.variants = variantsFromDom;
          this.variantCache[item.handle] = variantsFromDom;
          return item;
        }
      }

      // Fetch product JSON as a last resort (async) then re-render
      if (!this.variantCache[item.handle]) {
        this.variantCache[item.handle] = 'loading';
        fetch('/products/' + item.handle + '.js')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (!data || !data.variants) return;
            var variants = (data.variants || []).map(function (variant) {
              return { id: variant.id, title: variant.title, price: parseCents(variant.price) };
            }).filter(function (v) { return v.id && v.title; });
            if (variants.length) {
              Favourites.variantCache[item.handle] = variants;
              // Update stored items and re-render to show ranges
              Favourites.items = Favourites.items.map(function (i) {
                if (i.handle === item.handle) {
                  i.variants = variants;
                }
                return i;
              });
              Favourites.save();
              Favourites.render();
            }
          })
          .catch(function () {
            Favourites.variantCache[item.handle] = [];
          });
      }

      return item;
    },

    formatPriceRange: function formatPriceRange(item) {
      var prices = [];
      (item.variants || []).forEach(function (variant) {
        if (typeof variant.price === 'number' && !isNaN(variant.price)) {
          prices.push(variant.price);
        }
      });
      if (prices.length === 0 && item.price) {
        var basePrice = parseCents(item.price);
        if (!isNaN(basePrice)) prices.push(basePrice);
      }
      if (prices.length === 0) return '';
      var min = Math.min.apply(Math, prices);
      var max = Math.max.apply(Math, prices);
      if (min === max) return formatPrice(min);
      return formatPrice(min) + ' - ' + formatPrice(max);
    },

    save: function save() {
      if (!this.storageEnabled) return;
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
      } catch (error) {
        console.warn('Favourites: unable to save favourites.', error);
      }
    },

    load: function load() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (error) {
        console.warn('Favourites: unable to read favourites.', error);
        return [];
      }
    },

    render: function render() {
      this.updateButtons();
      this.updateCountBadges();
      this.renderList();
      this.renderPage();
      this.updateControls();
    },

    updateButtons: function updateButtons() {
      var _this = this;
      var buttons = document.querySelectorAll('[data-favourite-toggle]');
      buttons.forEach(function (button) {
        var handle = button.getAttribute('data-product-handle');
        var isActive = _this.items.some(function (item) {
          return item.handle === handle;
        });
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    },

    updateCountBadges: function updateCountBadges() {
      var count = this.items.length;
      var badges = document.querySelectorAll('[data-favourite-count]');
      badges.forEach(function (badge) {
        badge.textContent = count;
        if (count === 0) {
          badge.setAttribute('hidden', 'hidden');
        } else {
          badge.removeAttribute('hidden');
        }
      });
      var triggers = document.querySelectorAll('[data-favourite-open]');
      triggers.forEach(function (trigger) {
        trigger.classList.toggle('has-items', count > 0);
        if (count === 0) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    },

    renderList: function renderList() {
      if (!this.itemsContainer || !this.emptyMessage) return;
      var container = this.itemsContainer;
      container.innerHTML = '';
      if (this.items.length === 0) {
        this.emptyMessage.removeAttribute('hidden');
        return;
      }
      this.emptyMessage.setAttribute('hidden', 'hidden');
      this.items.forEach(function (item) {
        Favourites.hydrateVariants(item);
        var wrapper = document.createElement('div');
        wrapper.className = 'favourite-panel__item';

        var imageLink = document.createElement('a');
        imageLink.href = item.url || '#';
        imageLink.className = 'favourite-panel__item-image';
        var image = document.createElement('img');
        image.src = item.image || '//cdn.shopify.com/s/images/admin/no-image-large.gif';
        image.alt = item.title || '';
        imageLink.appendChild(image);
        wrapper.appendChild(imageLink);

        var content = document.createElement('div');
        content.className = 'favourite-panel__item-content';

        var title = document.createElement('p');
        title.className = 'favourite-panel__item-title';
        var link = document.createElement('a');
        link.href = item.url || '#';
        link.textContent = item.title || 'View product';
        title.appendChild(link);

        var price = document.createElement('p');
        price.className = 'favourite-panel__item-price';
        var priceText = Favourites.formatPriceRange(item);
        if (priceText) {
          var priceLink = document.createElement('a');
          priceLink.href = item.url || '#';
          priceLink.textContent = priceText;
          price.appendChild(priceLink);
        }

        var removeButton = document.createElement('button');
        removeButton.className = 'favourite-panel__remove small-text underline';
        removeButton.type = 'button';
        removeButton.textContent = getThemeString('favourites_remove', 'Remove');
        removeButton.setAttribute('data-favourite-remove', '');
        removeButton.setAttribute('data-product-handle', item.handle);

        content.appendChild(title);
        content.appendChild(price);
        content.appendChild(removeButton);

        wrapper.appendChild(content);
        container.appendChild(wrapper);
      });
    },

  renderPage: function renderPage() {
    if (!this.pageContainer || !this.pageItemsContainer || !this.pageEmptyMessage) return;
    var container = this.pageItemsContainer;
    container.innerHTML = '';
    if (this.items.length === 0) {
      this.pageEmptyMessage.removeAttribute('hidden');
      return;
    }
    this.pageEmptyMessage.setAttribute('hidden', 'hidden');
    this.items.forEach(function (item) {
      Favourites.hydrateVariants(item);
      Favourites.renderPageCard(item, container);
    });
  },

  renderPageCard: function renderPageCard(item, container) {
    var handle = item.handle;
    if (!handle) return;
    var useCache = this.cardCache[handle];
    if (useCache) {
      this.appendCardHtml(useCache, item, container);
      return;
    }
    fetch('/products/' + encodeURIComponent(handle) + '?view=card')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        Favourites.cardCache[handle] = html;
        Favourites.appendCardHtml(html, item, container);
      })
      .catch(function () {
        // graceful fallback
        var fallback = '<div class="product-block"><div class="block-inner"><div class="block-inner-inner product-image-wrapper"><a class="product-link" href="' + (item.url || '#') + '"><div class="image-label-wrap"><div class="product-block__image product-block__image--primary product-block__image--active"><img src="' + (item.image || '//cdn.shopify.com/s/images/admin/no-image-large.gif') + '" alt="' + (item.title || '') + '"></div></div></a></div><div class="product-info"><div class="inner"><div class="innerer"><a class="product-link" href="' + (item.url || '#') + '"><div class="product-block__title">' + (item.title || 'View product') + '</div></a></div></div></div></div></div>';
        Favourites.appendCardHtml(fallback, item, container);
      });
  },

  appendCardHtml: function appendCardHtml(html, item, container) {
    var temp = document.createElement('div');
    temp.innerHTML = html.trim();
    var cardEl = temp.querySelector('.product-block') || temp.firstElementChild;
    if (!cardEl) return;
    container.appendChild(cardEl);

    // Trigger theme image handling so hover/secondary images work
    if (window.theme && theme.ProductBlockManager && typeof theme.ProductBlockManager.loadImages === 'function') {
      theme.ProductBlockManager.loadImages(cardEl);
    }

    // Trigger lazyload on newly injected media so images fill the card
    try {
      var lazyNodes = cardEl.querySelectorAll('.lazyload, .lazyload--manual, [data-bgset], [data-lazy-bgset-src]');
      if (window.lazySizes && window.lazySizes.loader) {
        lazyNodes.forEach(function (node) {
          window.lazySizes.loader.unveil(node);
        });
        // also trigger reveal of any secondary/hover images
        if (window.lazySizes.autoSizer) {
          window.lazySizes.autoSizer.checkElems();
        }
      }
      // Fallback: if backgrounds still missing, set them directly
      var bgNodes = cardEl.querySelectorAll('.rimage-background');
      bgNodes.forEach(function (bg) {
        if (bg.style.backgroundImage) return;
        var src = bg.dataset.lazyBgsetSrc || bg.dataset.bgset || '';
        if (!src) return;
        bg.style.backgroundImage = 'url(' + src + ')';
      });
    } catch (e) {
      console.warn('Favourites: unable to unveil images', e);
    }

    // Ensure favourite toggle reflects saved state on newly injected cards
    this.updateButtons();
  },

    openPanel: function openPanel(opener) {
      if (!this.panel || !this.overlay) return;
      this.panel.classList.add('is-visible');
      this.overlay.classList.add('is-visible');
      this.panel.setAttribute('aria-hidden', 'false');
      if (opener) {
        opener.setAttribute('aria-expanded', 'true');
      }
      this.trackDrawer('open');
    },

    closePanel: function closePanel() {
      if (!this.panel || !this.overlay) return;
      this.panel.classList.remove('is-visible');
      this.overlay.classList.remove('is-visible');
      this.panel.setAttribute('aria-hidden', 'true');
      var triggers = document.querySelectorAll('[data-favourite-open]');
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      this.trackDrawer('close');
    },

    isPanelVisible: function isPanelVisible() {
      return this.panel && this.panel.classList.contains('is-visible');
    },

    parseVariantsFromCard: function parseVariantsFromCard(button) {
      var card = button.closest('.product-block');
      if (!card) return [];
      var script = card.querySelector('.bulk-add-variant-data');
      if (!script) return [];
      try {
        var parsed = JSON.parse(script.textContent || '[]');
        return (parsed || []).map(function (variant) {
          return {
            id: variant.id,
            title: variant.title
          };
        }).filter(function (variant) {
          return variant.id && variant.title;
        });
      } catch (error) {
        return [];
      }
    },

    normalize: function normalize(text) {
      return (text || '').trim().toLowerCase();
    },

    buildVariantOptions: function buildVariantOptions() {
      if (!this.variantSelect) return;
      var titles = [];
      this.items.forEach(function (item) {
        (item.variants || []).forEach(function (variant) {
          var norm = Favourites.normalize(variant.title);
          if (titles.indexOf(norm) === -1) titles.push(norm);
        });
      });
      if (titles.length === 0 && this.items.length > 0) {
        var fallback = this.items[0].variantId ? getThemeString('favourites_default_variant', 'Default') : null;
        if (fallback) titles.push(this.normalize(fallback));
      }
      var options = titles.map(function (norm) {
        var found = null;
        Favourites.items.forEach(function (item) {
          (item.variants || []).forEach(function (variant) {
            if (!found && Favourites.normalize(variant.title) === norm) {
              found = variant.title;
            }
          });
        });
        return found || norm;
      });

      var previous = this.variantSelect.value;
      this.variantSelect.innerHTML = '';

      options.forEach(function (title) {
        var opt = document.createElement('option');
        opt.value = title;
        opt.textContent = title;
        Favourites.variantSelect.appendChild(opt);
      });

      if (options.length === 0) {
        this.variantSelect.disabled = true;
      } else {
        this.variantSelect.disabled = false;
        if (previous && options.indexOf(previous) > -1) {
          this.variantSelect.value = previous;
        } else {
          this.variantSelect.value = options[0];
        }
      }
    },

    toggleAddButton: function toggleAddButton() {
      if (!this.addButton) return;
      var disabled = this.items.length === 0 || !this.variantSelect || !this.variantSelect.value;
      this.addButton.disabled = disabled;
      var countText = this.items.length > 0 ? ' (' + this.items.length + ')' : '';
      var addAllLabel = getThemeString('favourites_add_all', 'Add all to cart');
      this.addButton.textContent = disabled ? addAllLabel : addAllLabel + countText;
    },

  updateControls: function updateControls() {
    if (this.countTotal) {
      var label = this.items.length === 1
        ? getThemeString('favourites_count_single', 'Favourite')
        : getThemeString('favourites_count_plural', 'Favourites');
      this.countTotal.textContent = this.items.length + ' ' + label;
    }
    if (this.footer) {
      if (this.items.length === 0) {
        this.footer.setAttribute('hidden', 'hidden');
      } else {
        this.footer.removeAttribute('hidden');
      }
    }
    if (this.bulkContainer) {
      if (this.items.length === 0) {
        this.bulkContainer.setAttribute('hidden', 'hidden');
      } else {
        this.bulkContainer.removeAttribute('hidden');
      }
    }
    this.updateViewAllLink();
    this.buildVariantOptions();
    this.toggleAddButton();
  },

  updateViewAllLink: function updateViewAllLink() {
    if (!this.viewAllLink) return;
    // Show dedicated favourites page; it reads localStorage to render items.
    this.viewAllLink.setAttribute('href', '/pages/favourites');
  },

    updateStatus: function updateStatus(message) {
      if (!this.status) return;
      this.status.textContent = message || '';
    },

    addAllToCart: function addAllToCart() {
      if (!this.variantSelect || !this.addButton) return;
      var variantTitle = this.variantSelect.value;
      var selectedItems = [];
      var skipped = [];
      this.items.forEach(function (item) {
        var match = (item.variants || []).find(function (variant) {
          return Favourites.normalize(variant.title) === Favourites.normalize(variantTitle);
        });
        if (match && match.id) {
          selectedItems.push({ id: match.id, quantity: 1 });
        } else if (item.variantId) {
          selectedItems.push({ id: item.variantId, quantity: 1 });
        } else {
          skipped.push(item.title || item.handle);
        }
      });

      if (selectedItems.length === 0) {
        this.updateStatus(getThemeString('favourites_no_matching_variant', 'No matching variant to add.'));
        return;
      }

      this.setLoading(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: selectedItems })
      }).then(function (response) {
        if (!response.ok) throw new Error('Add failed');
        return response.json();
      }).then(function () {
        var addedTemplate = getThemeString('favourites_added', 'Added [COUNT] items to cart.');
        var skippedTemplate = getThemeString('favourites_added_skipped', 'Added [COUNT] items. Skipped: [SKIPPED]');
        var note = skipped.length
          ? skippedTemplate.replace('[COUNT]', selectedItems.length).replace('[SKIPPED]', skipped.join(', '))
          : addedTemplate.replace('[COUNT]', selectedItems.length);
        Favourites.updateStatus(note);
        Favourites.trackFavouriteEvent('favourite_add_to_cart', {
          label: 'favourite_bulk_add',
          item_count: selectedItems.length,
          variant_title: variantTitle,
          skipped_count: skipped.length
        });
        Favourites.save();
        Favourites.updateCountBadges();
        Favourites.toggleAddButton();
        document.documentElement.dispatchEvent(
          new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } })
        );
        Favourites.closePanel();
      }).catch(function () {
        Favourites.updateStatus(getThemeString('favourites_add_failed', 'Could not add items. Please try again.'));
      }).finally(function () {
        Favourites.setLoading(false);
      });
    },

    setLoading: function setLoading(isLoading) {
      if (!this.addButton) return;
      this.addButton.disabled = isLoading;
      var addAllLabel = getThemeString('favourites_add_all', 'Add all to cart');
      var addingLabel = getThemeString('favourites_adding', 'Adding...');
      this.addButton.textContent = isLoading ? addingLabel : addAllLabel + (this.items.length ? ' (' + this.items.length + ')' : '');
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    Favourites.init();
  });
})();
